import React from 'react';
import PropTypes from 'prop-types';
import AIconButton from './_atoms.icon-button';

export default function ASearchTag({ id, name, onClick }) {
	return (
		<div className="a-search-tag">
			<p>{ name }</p>
			<AIconButton
				type="close"
				onClick={onClick}
			/>
		</div>
	);
}

ASearchTag.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.search-tag.js